import axios from "../js/project-axios.js";

const login = data => {
    return axios.post("/auth/login", data, {
        public: true
    });
};

const refreshToken = refreshToken => {
    return axios.post("/auth/refreshToken", null, {
        headers: {
            Token: refreshToken
        },
        public: true,
        autoResult: false
    });
};

const logout = () => {
    return axios.post("/auth/logout", null, {
        public: true
    });
}

const isLogin = () => {
    return axios.get("/auth/isLogin", {
        public: true
    });
}

const currentUser = () => {
    return axios.get("/auth/currentUser");
}

const getConsts = type => {
    if (!type) {
        type = "LOGIN_SSO"
    }
    return axios.get("auth/getConsts", {
        params: {
            type
        },
        public: true
    });
};

const mineInfo = () => {
    return axios.get("/mine/info");
};

export {
    login,
    refreshToken,
    logout,
    isLogin,
    currentUser,
    getConsts,
    mineInfo
};

export default {
    login,
    refreshToken,
    logout,
    isLogin,
    currentUser,
    getConsts,
    mineInfo
};